// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/orgoverview/overview.actions.go

import { type Scope } from "~/hooks/useScope";
import { GET_CACHED_OVERVIEW } from "./action";

export function canGetCachedOverview(scope: Scope): boolean {
  return scope.iamActions.includes(GET_CACHED_OVERVIEW);
}
